import styled from 'styled-components';
import theme from '../../../feachers/theme';

import PlusIcon from '../../../assets/icons/plus-icon.svg';
import MinusIcon from '../../../assets/icons/minus-icon.svg';


export const Container = styled.div`
  position: relative;
  display: flex;
		margin: auto;
		padding: 0 10px;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  border: 2px solid #ECBF4B;
		border-radius: 40px;
		height: 42px;
		width: 130px;
`;

const Btn = styled.button`
  width: 23px;
  height: 23px;
  padding: 0;
  background-size: contain;
  background-repeat: no-repeat;
  background-position: 50% 50%;
  border: none;
  background-color: transparent;
  cursor: pointer;

  :hover {
    opacity: 0.6;
  }

  &:disabled {
    cursor: not-allowed;
  }
`;

export const AmountNum = styled.p`
    font-size: 24px;
		color: #333300;
    font-family: Mix Pudgy Panda;
`;

export const UpBtn = styled(Btn)`
    background-image: url(${PlusIcon});
`;

export const DownBtn = styled(Btn)`
    background-image: url(${MinusIcon});
`;
